import { useAuthStore } from '@/store/useAuthStore'
import { useTokenStore } from '@/store/useTokenStore'
import { smartDateReviver } from '@/utils/dateReviver'
import axios, { AxiosResponse } from 'axios'
import qs from 'qs'

export const backendApi = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || 'http://localhost:8000'),
  timeout: 60000,
})

backendApi.interceptors.request.use(
  (config) => {
    const token = useTokenStore.getState().token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

backendApi.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.data && !response.config.url?.includes('download') && !response.config.url?.includes('export')) {
      const jsonString = JSON.stringify(response.data)
      response.data = JSON.parse(jsonString, smartDateReviver)
    }
    return response
  },
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      setTimeout(() => {
        useTokenStore.getState().clearToken()
      }, 1000)
      useAuthStore.getState().setShowSessionExpired(true)
    }
    return Promise.reject(error?.response?.data)
  }
)

export const paramsSerializerOpt = (params: any) => {
  return {
    params: params,
    paramsSerializer: {
      serialize: (params: Record<string, any>) => qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }
}